/* -disable react/style-prop-object */
import React, { Component } from 'react';
import { FormattedNumber } from 'react-intl';

import './styles.css';

export const types = {
  EARLY: 'EARLY',
  ON_TIME: 'ON_TIME',
  LATE: 'LATE',
};

const typeToClassMap = {
  [types.EARLY]: 'DashboardCompletedOverviewComparativeItem--early',
  [types.ON_TIME]: 'DashboardCompletedOverviewComparativeItem--on-time',
  [types.LATE]: 'DashboardCompletedOverviewComparativeItem--late',
};
class DashboardCompletedOverviewComparativeItem extends Component {
  render() {
    const { className, value, label, type, quantity } = this.props;
    const typeClassName = typeToClassMap[type];

    return (
      <div
        className={`DashboardCompletedOverviewComparativeItem ${typeClassName} ${
          className || ''
        }`}
      >
        <div className="DashboardCompletedOverviewComparativeItem__info">
          <p className="DashboardCompletedOverviewComparativeItem__info-value">
            <FormattedNumber
              value={value / 100}
              style="percent"
              minimumFractionDigits={2}
              maximumFractionDigits={2}
            />
          </p>
          <div className="DashboardCompletedOverviewComparativeItem_Container">
            <span className="DashboardCompletedOverviewComparativeItem__info-label">
              {label}
            </span>
            <span className="DashboardCompletedOverviewComparativeItem_Quantity">
              {quantity}
            </span>
          </div>
        </div>

        <div
          className="DashboardCompletedOverviewComparativeItem__progress"
          style={{ width: `${value}%` }}
        />
      </div>
    );
  }
}

export default DashboardCompletedOverviewComparativeItem;
